import { useCallback, useEffect, useState } from 'react';
import { callAgoGetWithRetry } from '../auth/portalSession';

export async function fetchReservationCancelClosePendingSummary(fleetCode) {
  if (!fleetCode) {
    throw new Error('fleet_code is required');
  }
  return callAgoGetWithRetry({
    api_endpoint: 'api3:staff:cancel_close_review',
    request_type: 'GET',
    mode: 'summary',
    fleet_code: fleetCode,
  });
}

export function useReservationCancelClosePendingSummary({
  enabled = true,
  fleetCode,
  refreshKey = 0,
} = {}) {
  const [totalPending, setTotalPending] = useState(0);
  const [totalWarnings, setTotalWarnings] = useState(0);
  const [byFleet, setByFleet] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!enabled || !fleetCode) {
      setTotalPending(0);
      setTotalWarnings(0);
      setByFleet([]);
      return;
    }
    setLoading(true);
    try {
      const res = await fetchReservationCancelClosePendingSummary(fleetCode);
      setTotalPending(Number(res?.total_pending) || 0);
      setTotalWarnings(Number(res?.total_warnings) || 0);
      setByFleet(Array.isArray(res?.by_fleet) ? res.by_fleet : []);
    } catch (e) {
      setTotalPending(0);
      setTotalWarnings(0);
      setByFleet([]);
    } finally {
      setLoading(false);
    }
  }, [enabled, fleetCode]);

  useEffect(() => {
    refresh();
  }, [refresh, refreshKey]);

  return { totalPending, totalWarnings, byFleet, loading, refresh };
}

export function portalRoleShowsReservationCancelCloseReview(role) {
  return role === 'admin' || role === 'fleet' || role === 'support';
}
